import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomArtLabel, CustomFooter, CustomSearch } from '../../components';
import ExhibitionService from '../../service/ExhibitionService';
import EventBus from "../../common/EventBus";


const SearchFooter = (props) => {
   

    return (
       <CustomFooter props={props} themeColor="dark"></CustomFooter>
    );
};

export default SearchFooter;
